import { usePermissions } from '../hooks/usePermissions';

/**
 * Wrapper component to conditionally render content based on permissions
 * @param {string} module - Module name
 * @param {string} action - Action type ('read', 'create', 'update', 'delete')
 * @param {React.ReactNode} children - Content to render if permission is granted
 * @param {React.ReactNode} fallback - Optional fallback content if permission is denied
 */
const PermissionWrapper = ({ module, action, children, fallback = null }) => {
  const { hasPermission } = usePermissions();

  if (hasPermission(module, action)) {
    return children;
  }

  return fallback;
};

export default PermissionWrapper;

